import { render, staticRenderFns } from "./job-list.vue?vue&type=template&id=2a08b767&scoped=true"
import script from "./job-list.vue?vue&type=script&lang=js"
export * from "./job-list.vue?vue&type=script&lang=js"
import style0 from "./job-list.vue?vue&type=style&index=0&id=2a08b767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08b767",
  null
  
)

export default component.exports